import React, { Suspense, lazy } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhatsAppButton } from './components/ui/WhatsAppButton';
import { LanguageProvider } from './context/LanguageContext';
const IntroSection = lazy(() => import('./components/IntroSection').then(m => ({
  default: m.IntroSection
})));
const LocationSection = lazy(() => import('./components/LocationSection').then(m => ({
  default: m.LocationSection
})));
const QualitiesSection = lazy(() => import('./components/QualitiesSection').then(m => ({
  default: m.QualitiesSection
})));
const AmenitiesSection = lazy(() => import('./components/AmenitiesSection').then(m => ({
  default: m.AmenitiesSection
})));
const PhasesSection = lazy(() => import('./components/PhasesSection').then(m => ({
  default: m.PhasesSection
})));
const AvailabilitySection = lazy(() => import('./components/AvailabilitySection').then(m => ({
  default: m.AvailabilitySection
})));
const DeveloperSection = lazy(() => import('./components/DeveloperSection').then(m => ({
  default: m.DeveloperSection
})));
const ContactSection = lazy(() => import('./components/ContactSection').then(m => ({
  default: m.ContactSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SectionLoader = () => <div className="flex items-center justify-center py-24" data-id="element-0" data-mp="2zmeoiach9o8k">
    <div className="w-8 h-8 border-4 border-navy/20 border-t-navy rounded-full animate-spin" data-id="element-1" data-mp="33mf1dqjxhrdi"></div>
  </div>;
export function App() {
  return <LanguageProvider data-id="element-2" data-mp="38k6tolohjfi8">
      <div className="min-h-screen bg-white overflow-x-hidden" data-id="element-3" data-mp="38nuqput52k1p">
        <Navbar data-id="element-4" data-mp="3dlntsez5axxr" />
        <main data-id="element-5" data-mp="3dm5ylzzvikha">
          <Hero data-id="element-6" data-mp="3dirvgpjdy78s" />
          <Suspense fallback={<SectionLoader data-id="element-8" data-mp="nw2bq4xkjoqk" />} data-id="element-7" data-mp="nvj3jfxq0epq">
            <IntroSection data-id="element-9" data-mp="nuraocvicv35" />
            <LocationSection data-id="element-10" data-mp="nxn5hsc273nd" />
            <QualitiesSection data-id="element-11" data-mp="sudoanf90dch" />
            <AmenitiesSection data-id="element-12" data-mp="stc864jdl0nw" />
            <PhasesSection data-id="element-13" data-mp="swqajcs1h9vc" />
            <AvailabilitySection data-id="element-14" data-mp="36877lhgoowl" />
            <DeveloperSection data-id="element-15" data-mp="356ttacz3qbp" />
            <ContactSection data-id="element-16" data-mp="38kvegdtbvi3" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-17" data-mp="3ubriwojgwo63">
          <Footer data-id="element-18" data-mp="3uevqlvw5621i" />
        </Suspense>
        <WhatsAppButton data-id="element-19" data-mp="d57ep0qhqei0" />
      </div>
    </LanguageProvider>;
}